import { ArrowLeft } from "lucide-react";

/**
 * Hierarchical back button — placed below the section title to step out of the
 * current sub-screen back to the previous layer.
 *
 * Style: ghost/link button, left-aligned, mobile-friendly tap area (>=44px tall),
 * forest-700 text turning forest-900 on hover. Does not compete with the H1.
 */
export default function BackButton({ onClick, label = "Back", testId = "back-btn", className = "" }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 -ml-1 px-3 py-2 min-h-[44px] text-sm font-medium text-forest-700 hover:text-forest-900 hover:bg-forest-50 rounded-lg transition-colors ${className}`}
      aria-label={label}
    >
      <ArrowLeft className="w-4 h-4" /> {label}
    </button>
  );
}
